import { Button, Text, TextInput, Select, Textarea } from "@mantine/core";
import { IconSettings } from "@tabler/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useFormRender } from "../hooks/useFormRender";
import { adjustFormSchema } from "../pages/gi/debitNote";
import _ from "lodash";

const DebitNoteAdjustButton = ({ mainForm, disabled = false }) => {
  const { t } = useTranslation();
  const onSubmit = async ({ values, formMode }) => {
    await mainForm.saveValues(values);
    formAction.close();
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    adjustFormSchema,
    null,
    onSubmit
  );

  const handleActionClick = () => {
    const id = mainForm?.values._id;
    if (!id) return;
    formAction.open({ mode: "edit", id, data: mainForm.values });
  };

  return (
    <>
      {/* {JSON.stringify(mainForm.values.termination)} */}
      <Button fullWidth onClick={handleActionClick} disabled={disabled}>
        {t("Adjust Details")}
      </Button>
      {renderForm()}
    </>
  );
};

export default DebitNoteAdjustButton;
